import React from "react";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import AdminProductList from "../../components/Dashboard/AdminProductList";

const AllProducts = () => {
  return (
    <Box>
      {/* Action row */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 3,
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        <Typography sx={{ fontSize: 14, color: "#6b7280" }}>
          Manage your product catalogue
        </Typography>
        <Link to="/dashboard/admin/create" style={{ textDecoration: "none" }}>
          <Box
            sx={{
              bgcolor: "#194049",
              color: "#fff",
              fontSize: 13,
              fontWeight: 600,
              px: 3,
              py: 1,
              borderRadius: "8px",
              cursor: "pointer",
              "&:hover": { bgcolor: "#14313a" },
            }}
          >
            + Add Product
          </Box>
        </Link>
      </Box>

      <AdminProductList />
    </Box>
  );
};

export default AllProducts;
